<template>
  <div class="relative">
    <div class="mb-3">
      <small class="fsize12 bg-white font-medium text-dark">Meta Title</small>
      <el-input
        placeholder="Enter or Type..."
        v-model="metaTitle"
        class="rounded-xl mt-2"
      />
    </div>
    <div class="mb-3">
      <small class="fsize12 bg-white font-medium text-dark"
        >Meta Description</small
      >
      <el-input
        placeholder="Enter or Type..."
        v-model="metaDescription"
        class="rounded-xl mt-2"
      />
    </div>
    <div class="mb-3">
      <small class="fsize12 bg-white font-medium text-dark">Meta Keyword</small>
      <el-input
        placeholder="Enter or Type..."
        v-model="metaKeyword"
        class="rounded-xl mt-2"
      />
    </div>
    <div class="mb-3">
      <small class="fsize12 bg-white font-medium text-dark"
        >Meta Canonical</small
      >
      <el-input
        placeholder="Enter or Type..."
        v-model="metaCanonical"
        class="rounded-xl mt-2"
      />
    </div>
    <div class="grid grid-cols-2 gap-4 mt-8">
      <vs-button
        type="primary"
        class="bg-primary rounded-lg font-semibold py-4 fsize14"
        @click="handleInsertMeta"
        >Save</vs-button
      >

      <vs-button
        type="secondary"
        class="bg-secondary rounded-lg font-semibold py-4 fsize14"
        @click="closePopup"
        >Cancel</vs-button
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      productId: null,
      metaTitle: "",
      metaDescription: "",
      metaKeyword: "",
      metaCanonical: "",
    };
  },
  props: {
    insertMeta: {
      type: Object,
      required: true,
    },
    insertMetaPopup: {
      type: Boolean,
    },
  },
  watch: {
    insertMetaPopup(val) {
      if (val == true) {
        this.populateData();
      } else {
        this.resetData();
      }
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    async handleInsertMeta() {
      const payload = {
        productId: this.productId,
        metaTitle: this.metaTitle,
        metaDescription: this.metaDescription,
        metaKeyword: this.metaKeyword,
        metaCanonical: this.metaCanonical,
      };
      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let data = await this.$store.dispatch(
          "EcomProduct/insertMeta",
          payload
        );
        if (data.code === 200) {
          await this.$store.dispatch("EcomProduct/getAllProduct");
          loader.close();
          this.$emit("closePopup");
          await this.$swal({
            title: `Meta Tag Inserted successfully!`,
            type: "success",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.resetData();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
        await this.$swal({
          title: `Failed to Insert the Meta Tag!`,
          type: "error",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
    },
    populateData() {
      console.log(this.insertMeta, "insertMeta");
      if (this.insertMeta && !this.isObjectEmpty(this.insertMeta)) {
        this.productId = this.insertMeta._id ? this.insertMeta._id : null;
        this.metaTitle = this.insertMeta.metaTitle
          ? this.insertMeta.metaTitle
          : "";
        this.metaDescription = this.insertMeta.metaDescription
          ? this.insertMeta.metaDescription
          : "";
        this.metaKeyword = this.insertMeta.metaKeyword
          ? this.insertMeta.metaKeyword
          : "";
        this.metaCanonical = this.insertMeta.metaCanonical
          ? this.insertMeta.metaCanonical
          : "";
      }
    },
    resetData() {
      this.productId = null;
      this.metaTitle = "";
      this.metaDescription = "";
      this.metaKeyword = "";
      this.metaCanonical = "";
    },
    isObjectEmpty(objectName) {
      return (
        objectName &&
        Object.keys(objectName).length === 0 &&
        objectName.constructor === Object
      );
    },
  },
  mounted() {
    this.populateData();
  },
  computed: {
    // ...mapState("tags", ["tagsDetails"]),
    // ...mapState("EcomAttributes", [
    //   "EcomAttrinutes",
    //   "singleAttrinutesPrime",
    //   "singleAttrinutesSec",
    // ]),
    // ...mapState("EcomCategory", ["EcomCategory", "detailedCategory"]),
  },
};
</script>

<style>
.swal2-container {
  z-index: 9999 !important;
}
</style>
